import request from '@/router/axios';

/** 与其他业务模块一致：附件上传走 OSS put-file-attach */
export const uploadEndpoint = '/api/blade-resource/oss/endpoint/put-file-attach';

export const getList = (params) => {
    return request({
        url: '/api/produce/blade-dept/select/page',
        method: 'get',
        params
    })
}


export const remove = (id) => {
  return request({
    url: '/api/produce/blade-dept/delete/id',
    method: 'get',
    params: {
      id,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/produce/blade-dept/insert',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/produce/blade-dept/update',
    method: 'post',
    data: row
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/produce/blade-dept/select/id',
    method: 'get',
    params: {
      id,
    }
  })
}


